import React from "react";
import { SEGMENT_BZA, SEGMENT_BZA_ID, SEGMENT_CMC, SEGMENT_CMC_ID } from "../constants";
import SegmentedProductPage from "../SegmentedProductPage";
import CommercialAircraftAccidentsIncidentsData from "./CommercialAircraftAccidentsIncidentsData";
import BusinessJetAircraftAccidentsIncidentsData from "./BusinessJetAircraftAccidentsIncidentsData";
import { productPageProps } from "../../common/types/product";

export default function AircraftAccidentsIncidentsData({
	packageName,
	subscribeLink,
	testimonials,
}: productPageProps) {
	return (
		<SegmentedProductPage
			tabsDefinition={[
				{
					id: SEGMENT_CMC_ID,
					title: `${SEGMENT_CMC} ${packageName}`,
					renderContent: (tabsNav) => (
						<CommercialAircraftAccidentsIncidentsData
							packageName={packageName}
							subscribeLink={subscribeLink}
							tabsNav={tabsNav}
							testimonials={testimonials}
						/>
					),
				},
				{
					id: SEGMENT_BZA_ID,
					title: `${SEGMENT_BZA} ${packageName}`,
					renderContent: (tabsNav) => (
						<BusinessJetAircraftAccidentsIncidentsData
							packageName={packageName}
							subscribeLink={subscribeLink}
							tabsNav={tabsNav}
							testimonials={testimonials}
						/>
					),
				},
			]}
		/>
	);
}
